import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import moment from 'moment';
import { toast } from "react-toastify";
import { getTeams } from '../../../../http';
import { updateUserJobDescription } from '../../../../http';

const UpdateJobModal = ({ visible, onClose, initialData, onUpdate }) => {
  console.log("Initial Data",initialData);

  const [jobTitle, setJobTitle] = useState(initialData?.jobTitle || '');
  const [jobDescription, setJobDescription] = useState(initialData?.jobDescription || '');
  const [jobLocation, setJobLocation] = useState(initialData?.jobLocation || '');
  const [team, setTeam] = useState(initialData?.team || '');
  const [employmentStatus, setEmploymentStatus] = useState(initialData?.employmentStatus || '');
  const [employmentType, setEmploymentType] = useState(initialData?.employmentType || '');
  const [startDate, setStartDate] = useState(initialData?.startDate ? moment(initialData.startDate).format('YYYY-MM-DD') : '');

  const [defaultSelectedTeamName, defaultSetSelectedTeamName] = useState(initialData?.team?.name || '');


  useEffect(() => {
    if (initialData) {
      setJobTitle(initialData.jobTitle || '');
      setJobDescription(initialData.jobDescription || '');
      setJobLocation(initialData.jobLocation || '');
      setTeam(initialData?.team || '');
      setEmploymentStatus(initialData.employmentStatus || '');
      setEmploymentType(initialData.employmentType || '');
      setStartDate(initialData.startDate ? moment(initialData.startDate).format('YYYY-MM-DD') : '');
    }
    
   
  }, [initialData]);




  const handleUpdate = async () => {

    // setJobData(updatedData); // Update jobData state
    try {
      const updatedData = {
        jobTitle,
        jobDescription,
        jobLocation,
        team: team,
        employmentStatus,
        employmentType,
        startDate,
      };
     
      console.log("Initial Data",initialData)
      const response = await updateUserJobDescription(initialData._id, updatedData);
      
      // Show success toast notification
      if(response.status === 200){  
        console.log("On CLose",onClose)
        
        // Create the complete updated job object with all necessary fields
        const completeUpdatedJob = {
          ...initialData,
          ...updatedData,
          _id: initialData._id,
          employeeID: initialData.employeeID
        };
        
        // Call the onUpdate callback to update parent component state
        if (onUpdate) {
          onUpdate(completeUpdatedJob);
        }
        
        onClose();
        toast.success('Job updated successfully!');
      }
      
      
    } catch (err) {
      // Show error toast notification
      toast.error('Failed to update job!');
    }
  };

 
  return (
    <Modal show={visible} onHide={onClose} backdrop="static" centered>
      <Modal.Header>
        <Modal.Title>Update Job Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Form>

        <Form.Group controlId="formTeam" className="mb-3">
            <Form.Label>Select Team</Form.Label>
            <Form.Control
              as="select"
              value={team}
              disabled
             
              defaultValue={initialData?.team?._id || initialData?.team}
              required
            >

              <option value={initialData?.team?._id}>{initialData?.team?.name}</option>
  
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formJobTitle" className="mb-3">
            <Form.Label>Job Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter job title"
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="formJobDescription" className="mb-3">
            <Form.Label>Job Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter job description"
              value={jobDescription}
              onChange={(e) => setJobDescription(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="formJobLocation" className="mb-3">
            <Form.Label>Job Location</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter job location"
              value={jobLocation}
              onChange={(e) => setJobLocation(e.target.value)}
              required
            />
          </Form.Group>


          <Form.Group controlId="formEmploymentStatus" className="mb-3">
            <Form.Label>Employment Status</Form.Label>
            <Form.Control
              as="select"
              value={employmentStatus}
              onChange={(e) => setEmploymentStatus(e.target.value)}
              required
            >
              <option value="" disabled>Select Employment Status</option>
              <option value="Full-time">Full-time</option>
              <option value="Part-time">Part-time</option>
              <option value="Contract">Contract</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formEmploymentType" className="mb-3">
            <Form.Label>Employment Type</Form.Label>
            <Form.Control
              as="select"
              value={employmentType}
              onChange={(e) => setEmploymentType(e.target.value)}
              required
            >
              <option value="" disabled>Select Employment Type</option>
              <option value="Permanent">Permanent</option>
              <option value="Temporary">Temporary</option>
              <option value="Internship">Internship</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formStartDate" className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpdate}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateJobModal;
